import { BarChartD3 } from './barchart-base.js';

// Dividend calendar bar chart.
// Subclasses BarChartD3 and only contributes domain logic:
//   - bar coloring rule (actual vs. projected)
//   - click opens a details modal via the hidden link element
//   - X-axis shows month names

class DivCalendarD3 extends BarChartD3 {
    getDefaultOptions() {
        const palette = {
            actual: { default: '#4CAF50', hover: '#388E3C' },
            projected: { default: '#81C784', hover: '#66BB6A' }
        };
        return {
            colors: {
                palette: palette,
                classify: d => (d.meta && d.meta.hasProjectedData) ? 'projected' : 'actual'
            },
            valueFormat: 'currency',
            axisTickFormat: '$,.0f',
            showValueLabels: true,
            showLegend: true,
            legend: [
                { label: 'Actual', colorKey: 'actual' },
                { label: 'Projected', colorKey: 'projected' }
            ],
            showAxes: true,
            barPadding: 0.2,
            // Rely on the base class default margins (Y axis lives on the right, so it
            // reserves space there), but pin the left margin to 0 so the X-axis line and
            // grid start flush with the left edge — aligned with the block title/caption.
            margin: { left: 0 }
        };
    }

    // Click on a bar opens the details modal (existing mechanism with the hidden link).
    onBarClick(d, event) {
        const link = document.getElementById(this.root + '_detailslink');
        if (!link) return;
        // Month index is 1-based in the source data; modal expects 0-based.
        const monthIdx = (d.meta && d.meta.month) ? (d.meta.month - 1) : 0;
        link.setAttribute('data-p-idx', monthIdx);
        link.setAttribute('data-c-resize', false);
        link.setAttribute('data-c-closeonoutsideclick', true);
        link.click();
    }

    // X axis: month names. Short = 3-letter abbreviations (or first 3 chars as fallback).
    formatXAxisLabel(d, idx, total, slotWidth, strategy) {
        const full = d.label || '';
        if (strategy === 'short') {
            return d.shortLabel || full.substring(0, 3);
        }
        return full;
    }
}

Tango.registerComponent(DivCalendarD3);